import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { GATED_EXPORT_MODAL, EXPORT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { AppState } from '@chegg-wt/core/state'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { GatedExportModalData } from '@chegg-wt/core/state/bibliography/types'
import { Config } from '@chegg-wt/core/config'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { sortedCitationsSelector } from '@chegg-wt/core/state/bibliography/selectors'
import {
  emitComponentViewEvent,
  userClick,
} from '@chegg-wt/core/state/instrumentation/actions'
import { componentOrigins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamComponentViews'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import BaseGatedBibliographyModal from '../BaseGatedBibliographyModal'
import {
  GatedExportModalProps,
  GatedExportModalStateProps,
  GatedExportModalDispatchProps,
} from './types'

export const GatedExportModal: React.FC<GatedExportModalProps> = ({
  data,
  selectedCitations,
  navigated,
  openModal,
  modalOpenRioEvent,
  continueRioEvent,
  upgradeRioEvent,
}) => {
  const [isRioSent, setIsRioSent] = useState<boolean>(false)
  const { toUpgrade } = useRoutesContext()
  const premiumAccountCopy = `${Config.siteName} ${Config.premiumAccountCopy}`
  const message = `Free accounts cannot export to ${data.exportName}. Please upgrade to ${premiumAccountCopy} to use this feature.`
  const header = `Export to ${data.exportName}`

  useEffect(() => {
    if (!isRioSent) {
      modalOpenRioEvent(header)
      setIsRioSent(true)
    }
  })

  const onUpgrade = (buttonText: string) => {
    upgradeRioEvent(buttonText)
    navigated(toUpgrade())
  }

  const onContinue = (buttonText: string) => {
    continueRioEvent(buttonText)
    openModal({
      name: EXPORT_MODAL,
      data: { selectedCitations, handleComplete: data.handleComplete },
    })
  }

  return (
    <BaseGatedBibliographyModal
      modalName={GATED_EXPORT_MODAL}
      header={header}
      message={message}
      isDismissible
      onContinue={onContinue}
      onUpgrade={onUpgrade}
    />
  )
}

const mapStateToProps = (state: AppState): GatedExportModalStateProps => ({
  data: modalDataSelector(state) as GatedExportModalData,
  selectedCitations: sortedCitationsSelector(state),
})

const mapDispatchToProps: GatedExportModalDispatchProps = {
  navigated,
  openModal,
  modalOpenRioEvent: (text: string) =>
    emitComponentViewEvent({
      origin: componentOrigins.exportToWordOpen,
      text,
    }),
  continueRioEvent: (text: string) =>
    userClick({ origin: origins.gatedExportContinueCTA, text }),
  upgradeRioEvent: (text: string) =>
    userClick({ origin: origins.gatedExportUpgradeCTA, text }),
}

export default connect(mapStateToProps, mapDispatchToProps)(GatedExportModal)
